class SubscriptionUpgrade extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('#upgrade-subscription').addEventListener('click', e => {
      e.preventDefault();

      const currentLabel = this.getCurrentSubscriptionLabel();
      const newLabel = this.getNewSubscriptionLabel();
      const productTitle = this.getAttribute('data-product-title') || 'Product';

      this.upgradeSubscription(this, this.getAttribute('data-line'), this.getAttribute('data-selling-plan'), currentLabel, newLabel, productTitle);
    });
  }

  getCurrentSubscriptionLabel() {
    const cartItem = this.closest('tr') || this.closest('[data-cart-item]') || this.closest('.cart-item');
    if (!cartItem) return 'One time';

    const productOptionParagraph = cartItem.querySelector('p.product-option');
    if (productOptionParagraph && productOptionParagraph.textContent.trim()) {
      return productOptionParagraph.textContent.trim();
    }

    return 'One time';
  }

  getNewSubscriptionLabel() {
    const clickedElement = this.querySelector('#upgrade-subscription span');
    return clickedElement ? clickedElement.textContent.trim() : 'One time';
  }

  upgradeSubscription(obj, line, selling_plan_id, currentLabel, newLabel, productTitle) {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartItem = cart.items.find((item, index) => index + 1 === parseInt(line));
        if (!cartItem) {
          console.error('Cart item not found for line:', line);
          return;
        }

        const properties = cartItem.properties || {};

        if (selling_plan_id && selling_plan_id != 0) {
          properties._is_subscription = 'true';
        } else {
          properties._is_subscription = 'false';
        }

        let updateItem = {
          line: line,
          selling_plan: selling_plan_id == 0 ? null : selling_plan_id,
          properties: properties
        };

        return fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updateItem)
        });
      })
      .then((response) => {
        if (!response) return;
        return response.json();
      })
      .then((data) => {
        obj.parentElement.parentElement.parentElement.querySelector('.quantity__input').dispatchEvent(new Event("change", { bubbles: true }));

        const isModalEnabled = window.Shopify?.theme?.enable_subscription_update_modal === true;
        
        if (isModalEnabled && typeof window.showSubscriptionUpgradeModal === 'function') {
          window.showSubscriptionUpgradeModal(currentLabel, newLabel, productTitle);
        } else if (isModalEnabled) {
          setTimeout(() => {
            if (typeof window.showSubscriptionUpgradeModal === 'function') {
              window.showSubscriptionUpgradeModal(currentLabel, newLabel, productTitle);
            }
          }, 500);
        }
      })
      .catch((error) => {
        console.error('Error upgrading subscription:', error);
      });
  }


}

customElements.define('subs-upgrade', SubscriptionUpgrade);